"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8605],{

/***/ 78605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SplitScreenBarCharts_SplitScreenBarCharts; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/GetData.ts
var GetData = __webpack_require__(17004);
// EXTERNAL MODULE: ./components/Shared/SkeletonLoader/SkeletoLoader.tsx
var SkeletoLoader = __webpack_require__(58663);
// EXTERNAL MODULE: ./services/Requests.ts
var Requests = __webpack_require__(19061);
// EXTERNAL MODULE: ./services/ArabicTitles.tsx
var ArabicTitles = __webpack_require__(9419);
// EXTERNAL MODULE: ./store/Store.tsx + 11 modules
var Store = __webpack_require__(44739);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(42772);
// EXTERNAL MODULE: ./reducers/MarketsSlice.tsx
var MarketsSlice = __webpack_require__(36043);
// EXTERNAL MODULE: ./reducers/MarketMoversSlice.tsx
var MarketMoversSlice = __webpack_require__(65192);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Shared/SplitScreenBarCharts/MarketMovers/MarketMovers.tsx




var MarketMovers = function(param) {
    var marketId = param.marketId;
    var ref = (0,react.useState)([]), gainers = ref[0], setGainers = ref[1];
    var ref1 = (0,react.useState)([]), losers = ref1[0], setLosers = ref1[1];
    var marketMovers = (0,es/* useSelector */.v9)(function(state) {
        return state.marketmovers;
    });
    (0,react.useEffect)(function() {
        setGainersLosers(marketId);
    }, [
        marketId,
        marketMovers
    ]);
    var setGainersLosers = function(marketId) {
        var ref, ref1;
        // console.log('IDcurrentMarket=>', marketId);
        var currentMarket = ((ref = marketMovers[marketId]) === null || ref === void 0 ? void 0 : ref.data) ? (ref1 = marketMovers[marketId]) === null || ref1 === void 0 ? void 0 : ref1.data : {};
        // console.log('currentMarket=>', currentMarket);
        if (currentMarket) {
            var allGainers = (currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.gainers) || [];
            if (Array.isArray(allGainers) && (allGainers === null || allGainers === void 0 ? void 0 : allGainers.length) > 0) {
                allGainers = allGainers.slice().sort(function(a, b) {
                    return (b === null || b === void 0 ? void 0 : b.ChangePercent) - (a === null || a === void 0 ? void 0 : a.ChangePercent);
                });
            }
            // console.log('allGainersCurrentMarket=>', allGainers);
            setGainers(allGainers);
            var allLosers = (currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.losers) || [];
            // console.log('allLosersCurrentMarket=>', allLosers);
            setLosers(allLosers);
        }
    };
    // useEffect(() => {
    //   console.log('gainers==>', gainers);
    // }, [gainers]);
    // useEffect(() => {
    //   console.log('losers==>', losers);
    // }, [losers]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "row",
        children: [
            marketId == "999" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "الرابحون"
                            }),
                            gainers && (gainers === null || gainers === void 0 ? void 0 : gainers.length) && (gainers === null || gainers === void 0 ? void 0 : gainers.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "table-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: "table table-borderless",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: gainers.map(function(gainer, index) {
                                            var ref;
                                            var row = gainer;
                                            //   console.log('rowCurrentMarket=>',row);
                                            var percentageWidth = index == 0 ? 100 : (row === null || row === void 0 ? void 0 : row.ChangePercent) / ((ref = gainers[0]) === null || ref === void 0 ? void 0 : ref.ChangePercent) * 100;
                                            // console.log("1-",percentageWidth,"2-",row?.ChangePercent,"3-",gainers[0]?.ChangePercent)
                                            if (index >= 5) return null;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: "marketMoversRow cursor-pointer Nine",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: row === null || row === void 0 ? void 0 : row.TickerSymbol
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "desc",
                                                        children: row === null || row === void 0 ? void 0 : row.TickerArabicName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "text-success",
                                                        children: "".concat(row === null || row === void 0 ? void 0 : row.ChangePercent, "%")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        style: {
                                                            width: "50%"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "progress p-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "progress-bar bg-success",
                                                                style: {
                                                                    width: "".concat(percentageWidth, "%")
                                                                }
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, row === null || row === void 0 ? void 0 : row.TickerID);
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "الخاسرون"
                            }),
                            losers && (losers === null || losers === void 0 ? void 0 : losers.length) && (losers === null || losers === void 0 ? void 0 : losers.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "table-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: "table table-borderless",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: losers.map(function(loser, index) {
                                            var ref, ref1;
                                            var row = loser;
                                            var percentageWidth = index == 0 ? 100 : (row === null || row === void 0 ? void 0 : row.ChangePercent) / ((ref = losers[0]) === null || ref === void 0 ? void 0 : ref.ChangePercent) * 100;
                                            if (index >= 5) return null;
                                            console.log("1.", percentageWidth, "2.", row === null || row === void 0 ? void 0 : row.ChangePercent, "3.", (ref1 = losers[0]) === null || ref1 === void 0 ? void 0 : ref1.ChangePercent);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: "marketMoversRow cursor-pointer Nine",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: row === null || row === void 0 ? void 0 : row.TickerSymbol
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "desc",
                                                        children: row === null || row === void 0 ? void 0 : row.TickerArabicName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "text-danger",
                                                        children: parseInt(row === null || row === void 0 ? void 0 : row.ChangePercent) > 0 ? "".concat(Math.abs(row === null || row === void 0 ? void 0 : row.ChangePercent), "%") : "".concat(Math.abs(row === null || row === void 0 ? void 0 : row.ChangePercent), "%-")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        style: {
                                                            width: "50%"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "progress p-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "progress-bar bg-danger",
                                                                style: {
                                                                    width: "".concat(Math.abs(percentageWidth), "%")
                                                                }
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, row === null || row === void 0 ? void 0 : row.TickerID);
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "الرابحون"
                            }),
                            gainers && (gainers === null || gainers === void 0 ? void 0 : gainers.length) && (gainers === null || gainers === void 0 ? void 0 : gainers.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "table-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: "table table-borderless",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: gainers.map(function(gainer, index) {
                                            var ref;
                                            var row = gainer;
                                            //   console.log('rowCurrentMarket=>',row);
                                            var percentageWidth = index == 0 ? 100 : (row === null || row === void 0 ? void 0 : row.ChangePercent) / ((ref = gainers[0]) === null || ref === void 0 ? void 0 : ref.ChangePercent) * 100;
                                            if (index >= 5) return null;
                                            // console.log("1-",percentageWidth,"2-",row?.ChangePercent,"3-",gainers[0]?.ChangePercent)
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/quotes/" + (row === null || row === void 0 ? void 0 : row.TickerID),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "marketMoversRow cursor-pointer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: row === null || row === void 0 ? void 0 : row.TickerSymbol
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "desc",
                                                            children: row === null || row === void 0 ? void 0 : row.TickerArabicName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-success",
                                                            children: "".concat(row === null || row === void 0 ? void 0 : row.ChangePercent, "%")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            style: {
                                                                width: "50%"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "progress p-0",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "progress-bar bg-success",
                                                                    style: {
                                                                        width: "".concat(percentageWidth, "%")
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, row === null || row === void 0 ? void 0 : row.TickerID)
                                            }, row === null || row === void 0 ? void 0 : row.TickerID);
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "الخاسرون"
                            }),
                            losers && (losers === null || losers === void 0 ? void 0 : losers.length) && (losers === null || losers === void 0 ? void 0 : losers.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "table-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: "table table-borderless",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: losers.map(function(loser, index) {
                                            var ref;
                                            var row = loser;
                                            var percentageWidth = index == 0 ? 100 : (row === null || row === void 0 ? void 0 : row.ChangePercent) / ((ref = losers[0]) === null || ref === void 0 ? void 0 : ref.ChangePercent) * 100;
                                            if (index >= 5) return null;
                                            // console.log("1.",percentageWidth,"2.",row?.ChangePercent,"3.",losers[0]?.ChangePercent)
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/quotes/" + (row === null || row === void 0 ? void 0 : row.TickerID),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "marketMoversRow cursor-pointer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: row === null || row === void 0 ? void 0 : row.TickerSymbol
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "desc",
                                                            children: row === null || row === void 0 ? void 0 : row.TickerArabicName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-danger",
                                                            children: parseInt(row === null || row === void 0 ? void 0 : row.ChangePercent) > 0 ? "".concat(Math.abs(row === null || row === void 0 ? void 0 : row.ChangePercent), "%") : "".concat(Math.abs(row === null || row === void 0 ? void 0 : row.ChangePercent), "%-")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            style: {
                                                                width: "50%"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "progress p-0",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "progress-bar bg-danger",
                                                                    style: {
                                                                        width: "".concat(Math.abs(percentageWidth), "%")
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, row === null || row === void 0 ? void 0 : row.TickerID)
                                            }, row === null || row === void 0 ? void 0 : row.TickerID);
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            }),
            (gainers === null || gainers === void 0 ? void 0 : gainers.length) == 0 && (losers === null || losers === void 0 ? void 0 : losers.length) == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "هذا السوق مغلق حالياً, ستتوفر البيانات عند افتتاح السوق"
            })
        ]
    });
};
/* harmony default export */ var MarketMovers_MarketMovers = (MarketMovers);

// EXTERNAL MODULE: ./services/TimeVariables.tsx
var TimeVariables = __webpack_require__(45374);
// EXTERNAL MODULE: ./services/parseZagApiResponse.ts
var parseZagApiResponse = __webpack_require__(95066);
;// CONCATENATED MODULE: ./components/Shared/SplitScreenBarCharts/SplitScreenBarCharts.tsx
// import { useEffect, useState } from 'react';
// import GetData from '../../../services/GetData';
// import SkeletonLoader from '../SkeletonLoader/SkeletoLoader';
// import { zagTrader } from '../../../services/Requests';
// import { marketMoversTitle } from 'apps/frontend/services/ArabicTitles';
// import { useAppDispatch, RootState } from 'apps/frontend/store/Store';
// import { useSelector } from 'react-redux';
// import { getMarkets } from 'apps/frontend/reducers/MarketsSlice';
// import { setMarketMovers } from 'apps/frontend/reducers/MarketMoversSlice';
// import MarketMovers from './MarketMovers/MarketMovers';
// import {
//   marketsTimer,
//   marketsMoversTimer,
// } from 'apps/frontend/services/TimeVariables';
// import { requests, iraqIdentifier, iraqCode } from '../../../services/Requests';
// const SplitScreenBarCharts = () => {
//   const [wait, setWait] = useState(false);
//   const [marketID, setMarketID] = useState();
//   const dispatch = useAppDispatch();
//   const { marketsList, marketsTime, loading } = useSelector(
//     (state: RootState) => state.markets
//   );
//   const marketMovers = useSelector((state: RootState) => state.marketmovers);
//   // use of redux for markets menu
//   useEffect(() => {
//     const minutesInMilliseconds = marketsTimer?.minutesInMilliseconds;
//     const specificTimeAgo = Date.now() - minutesInMilliseconds;
//     marketsTime < specificTimeAgo && dispatch(getMarkets());
//   }, []);
//   useEffect(() => {
//     console.log('marketsList=>', marketsList);
//     marketsList &&
//       marketsList?.length &&
//       marketsList?.length > 0 &&
//       setMarketID(marketsList[0].marketId);
//   }, [marketsList]);
//   useEffect(() => {
//     if (marketID == 999) {
//       // IraqGainerLoser(marketID);
//     } else {
//       getMarketBarChartData(marketID);
//     }
//   }, [marketID]);
//   const IraqGainerLoser = (marketId) => {
//     setWait(true);
//     const minutesInMilliseconds = marketsMoversTimer?.minutesInMilliseconds;
//     const specificTimeAgo = Date.now() - minutesInMilliseconds;
//     const currentDate = new Date();
//     const currentTime = currentDate.getTime();
//     const data = {
//       Identifier: iraqIdentifier, // replace with actual identifier if dynamic
//       LanguageCode: iraqCode,
//     };
//     if (marketId > 0) {
//       if (
//         marketMovers[marketId]?.marketIdTime < specificTimeAgo ||
//         !(marketId in marketMovers)
//       ) {
//         GetData(`${requests.iraqGainerLoser}`, data, 'post', false)
//           .then((res) => {
//             // console.log("res=>",res.data[0])
//             const resp = res.data[0];
//             if (
//               (resp?.gainers && resp?.gainers?.length > 0) ||
//               (resp?.losers && resp?.losers?.length > 0)
//             ) {
//               const gainersList =
//                 resp?.gainers?.length > 5
//                   ? resp?.gainers.slice(0, 5)
//                   : resp?.gainers;
//               const losersList =
//                 resp?.losers?.length > 5
//                   ? resp?.losers.slice(0, 5)
//                   : resp?.losers;
//               const resultData = { gainers: gainersList, losers: losersList };
//               let marketMoversContainer = { ...marketMovers };
//               marketMoversContainer = {
//                 ...marketMoversContainer,
//                 [marketId]: { data: resultData, marketIdTime: currentTime },
//               };
//               dispatch(setMarketMovers(marketMoversContainer));
//             }
//             setWait(false);
//           })
//           .catch((err) => {
//             console.warn(err);
//           });
//       } else {
//         setWait(false);
//       }
//     }
//   };
//   const getMarketBarChartData = (marketId) => {
//     setWait(true);
//     const minutesInMilliseconds = marketsMoversTimer?.minutesInMilliseconds;
//     const specificTimeAgo = Date.now() - minutesInMilliseconds;
//     const currentDate = new Date();
//     const currentTime = currentDate.getTime();
//     if (marketId > 0) {
//       if (
//         marketMovers[marketId]?.marketIdTime < specificTimeAgo ||
//         !(marketId in marketMovers)
//       ) {
//         const glapi =
//           marketId == 100
//             ? `${zagTrader}api/GainerLoserAPI.php?langid=2&sectorId=32&marketId=100`
//             : `${zagTrader}api/GainerLoserAPI.php?marketId=${marketId}`;
//         GetData(glapi, {}, 'get', false)
//           .then((res) => {
//             if (
//               (res?.data?.gainers && res?.data?.gainers?.length > 0) ||
//               (res?.data?.losers && res?.data?.losers?.length > 0)
//             ) {
//               const gainersList =
//                 res?.data?.gainers?.length > 5
//                   ? res?.data?.gainers.slice(0, 5)
//                   : res?.data?.gainers;
//               const losersList =
//                 res?.data?.losers?.length > 5
//                   ? res?.data?.losers.slice(0, 5)
//                   : res?.data?.losers;
//               const resultData = { gainers: gainersList, losers: losersList };
//               let marketMoversContainer = { ...marketMovers };
//               marketMoversContainer = {
//                 ...marketMoversContainer,
//                 [marketId]: { data: resultData, marketIdTime: currentTime },
//               };
//               dispatch(setMarketMovers(marketMoversContainer));
//             }
//             setWait(false);
//           })
//           .catch((err) => {
//             setWait(false);
//             console.warn(err);
//           });
//       } else {
//         setWait(false);
//       }
//     }
//   };
//   useEffect(() => {
//     console.log('marketsList===>', marketsList);
//   }, [marketsList])
//   return (
//     <>
//       <div className="marketChart">
//         <div className="yellowTitle">
//           <h3>{marketMoversTitle}</h3>
//         </div>
//         <div className="chartBox">
//           <div className="chartTop">
//             <ul className="d-flex">
//               {loading && <SkeletonLoader />}
//               {
//                 // show bar chart menu
//                 marketsList?.length > 0 &&
//                 marketsList.map((item: any, index: number) => {
//                   return (
//                     <li key={index} className="nav-item">
//                       <a
//                         onClick={() => setMarketID(item?.marketId)}
//                         className={`nav-link ${item?.marketId === marketID ? 'active' : ''
//                           }`}
//                       >
//                         {item?.name ? item?.name : item?.marketArabicName}
//                       </a>
//                     </li>
//                   );
//                 })
//               }
//             </ul>
//           </div>
//           {wait && <SkeletonLoader count={5} />}
//           {!wait && marketID && marketID > 0 && (
//             <MarketMovers marketId={marketID} />
//           )}
//         </div>
//       </div>
//     </>
//   );
// };
// export default SplitScreenBarCharts;

















var SplitScreenBarCharts = function() {
    var ref = (0,react.useState)(false), wait = ref[0], setWait = ref[1];
    var ref1 = (0,react.useState)(), marketID = ref1[0], setMarketID = ref1[1];
    var ref2 = (0,react.useState)(false), connectionError = ref2[0], setConnectionError = ref2[1];
    var ref3 = (0,react.useState)({}), userCountry = ref3[0], setUserCountry = ref3[1];
    var ref4 = (0,react.useState)(false), isUserCountryLoaded = ref4[0], setIsUserCountryLoaded = ref4[1];
    var ref5 = (0,react.useState)(false), isUserCountryFailed = ref5[0], setIsUserCountryFailed = ref5[1];
    var ref6 = (0,react.useState)(false), isInitialMarketResolved = ref6[0], setIsInitialMarketResolved = ref6[1];
    var marketTabRefs = (0,react.useRef)({});
    var dispatch = (0,Store/* useAppDispatch */.T)();
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        return state.markets;
    }), marketsList = ref7.marketsList, marketsTime = ref7.marketsTime, loading = ref7.loading;
    var marketMovers = (0,es/* useSelector */.v9)(function(state) {
        return state.marketmovers;
    });
    // use of redux for markets menu
    (0,react.useEffect)(function() {
        var minutesInMilliseconds = TimeVariables/* marketsTimer */.IL === null || TimeVariables/* marketsTimer */.IL === void 0 ? void 0 : TimeVariables/* marketsTimer.minutesInMilliseconds */.IL.minutesInMilliseconds;
        var specificTimeAgo = Date.now() - minutesInMilliseconds;
        marketsTime < specificTimeAgo && dispatch((0,MarketsSlice/* getMarkets */.tn)());
    }, []);
    (0,react.useEffect)(function() {
        console.log("marketsList===>", marketsList);
    }, [
        marketsList
    ]);
    var getUserCountry = function() {
        setIsUserCountryFailed(false);
        (0,GetData/* default */.Z)(Requests/* requests.usercountry */.E7.usercountry, {}, "get", false).then(function(res) {
            var ref;
            var resp = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.response) || (res === null || res === void 0 ? void 0 : res.data) || {};
            setUserCountry(resp);
            setIsUserCountryLoaded(true);
        }).catch(function(err) {
            console.warn(err);
            setIsUserCountryFailed(true);
            setUserCountry({});
            setIsUserCountryLoaded(true);
        });
    };
    (0,react.useEffect)(function() {
        getUserCountry();
    }, []);
    var getTargetMarketByCountry = function(list, country) {
        var code = ((country === null || country === void 0 ? void 0 : country.code) || "").toUpperCase();
        var apiName = String((country === null || country === void 0 ? void 0 : country.name) || "");
        var apiCity = String((country === null || country === void 0 ? void 0 : country.city) || "");
        var normalizeText = function(value) {
            return String(value || "").toLowerCase().replace(/[^a-z0-9\s]/g, " ").replace(/\s+/g, " ").trim();
        };
        var displayNames = new Set();
        if (apiName) {
            displayNames.add(apiName);
        }
        if (apiCity) {
            displayNames.add(apiCity);
        }
        if (code && typeof Intl !== "undefined" && Intl.DisplayNames) {
            try {
                var enName = new Intl.DisplayNames([
                    "en"
                ], {
                    type: "region"
                }).of(code);
                enName && displayNames.add(enName);
            } catch (_err) {}
        }
        var candidates = Array.from(displayNames).map(normalizeText).filter(Boolean);
        var getScore = function(item) {
            var marketEnglish = normalizeText((item === null || item === void 0 ? void 0 : item.marketEnglishName) || "");
            var marketSymbol = normalizeText((item === null || item === void 0 ? void 0 : item.symbol) || "");
            var score = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var candidate = _step.value;
                    if (!candidate) continue;
                    if (marketEnglish.includes(candidate) || candidate.includes(marketEnglish)) {
                        score += 100;
                    }
                    var tokens = candidate.split(" ").filter(function(token) {
                        return token.length > 2;
                    });
                    var tokenHits = tokens.filter(function(token) {
                        return marketEnglish.includes(token) || marketSymbol === token;
                    }).length;
                    score += tokenHits * 10;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return score;
        };
        var scoredMatches = list.map(function(item) {
            return {
                item: item,
                score: getScore(item)
            };
        }).filter(function(entry) {
            return entry.score > 0;
        }).sort(function(a, b) {
            return b.score - a.score;
        });
        if (scoredMatches.length) {
            return scoredMatches[0].item;
        }
        return list[0];
    };
    (0,react.useEffect)(function() {
        var ref;
        if (!isUserCountryLoaded || !(marketsList === null || marketsList === void 0 ? void 0 : marketsList.length) || isInitialMarketResolved) {
            return;
        }
        if (isUserCountryFailed) {
            var ref1;
            setMarketID((ref1 = marketsList[0]) === null || ref1 === void 0 ? void 0 : ref1.marketId);
            setIsInitialMarketResolved(true);
            return;
        }
        var matchedMarket = getTargetMarketByCountry(marketsList, userCountry);
        setMarketID((ref = matchedMarket || marketsList[0]) === null || ref === void 0 ? void 0 : ref.marketId);
        setIsInitialMarketResolved(true);
    }, [
        isUserCountryLoaded,
        marketsList,
        userCountry,
        isInitialMarketResolved,
        isUserCountryFailed
    ]);
    (0,react.useEffect)(function() {
        if (marketID == 999) {
        // IraqGainerLoser(marketID);
        } else {
            // console.log('GETMARKET',marketID);
            getMarketBarChartData(marketID);
        }
    }, [
        marketID
    ]);
    (0,react.useEffect)(function() {
        if (!marketID) return;
        var activeTab = marketTabRefs.current[String(marketID)];
        if (activeTab) {
            activeTab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    }, [
        marketID
    ]);
    var IraqGainerLoser = function(marketId) {
        setWait(true);
        setConnectionError(false);
        var minutesInMilliseconds = TimeVariables/* marketsMoversTimer */.l5 === null || TimeVariables/* marketsMoversTimer */.l5 === void 0 ? void 0 : TimeVariables/* marketsMoversTimer.minutesInMilliseconds */.l5.minutesInMilliseconds;
        var specificTimeAgo = Date.now() - minutesInMilliseconds;
        var currentDate = new Date();
        var currentTime = currentDate.getTime();
        var data = {
            Identifier: Requests/* iraqIdentifier */.RU,
            LanguageCode: Requests/* iraqCode */.bb
        };
        if (marketId > 0) {
            var ref;
            if (((ref = marketMovers[marketId]) === null || ref === void 0 ? void 0 : ref.marketIdTime) < specificTimeAgo || !(marketId in marketMovers)) {
                (0,GetData/* default */.Z)("".concat(Requests/* requests.iraqGainerLoser */.E7.iraqGainerLoser), data, "post", false).then(function(res) {
                    var ref, ref1;
                    // console.log("res=>",res.data[0])
                    var resp = res.data[0];
                    if ((resp === null || resp === void 0 ? void 0 : resp.gainers) && (resp === null || resp === void 0 ? void 0 : (ref = resp.gainers) === null || ref === void 0 ? void 0 : ref.length) > 0 || (resp === null || resp === void 0 ? void 0 : resp.losers) && (resp === null || resp === void 0 ? void 0 : (ref1 = resp.losers) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                        var ref2, ref3;
                        var gainersList = (resp === null || resp === void 0 ? void 0 : (ref2 = resp.gainers) === null || ref2 === void 0 ? void 0 : ref2.length) > 5 ? resp === null || resp === void 0 ? void 0 : resp.gainers.slice(0, 5) : resp === null || resp === void 0 ? void 0 : resp.gainers;
                        var losersList = (resp === null || resp === void 0 ? void 0 : (ref3 = resp.losers) === null || ref3 === void 0 ? void 0 : ref3.length) > 5 ? resp === null || resp === void 0 ? void 0 : resp.losers.slice(0, 5) : resp === null || resp === void 0 ? void 0 : resp.losers;
                        var resultData = {
                            gainers: gainersList,
                            losers: losersList
                        };
                        var marketMoversContainer = (0,_object_spread/* default */.Z)({}, marketMovers);
                        marketMoversContainer = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketMoversContainer), (0,_define_property/* default */.Z)({}, marketId, {
                            data: resultData,
                            marketIdTime: currentTime
                        }));
                        dispatch((0,MarketMoversSlice/* setMarketMovers */.n)(marketMoversContainer));
                    }
                    setWait(false);
                }).catch(function(err) {
                    setWait(false);
                    setConnectionError(true);
                    console.warn(err);
                });
            } else {
                setWait(false);
            }
        }
    };
    var getMarketBarChartData = function(marketId) {
        setWait(true);
        setConnectionError(false);
        // console.log('marketID=>', marketId);
        var minutesInMilliseconds = TimeVariables/* marketsMoversTimer */.l5 === null || TimeVariables/* marketsMoversTimer */.l5 === void 0 ? void 0 : TimeVariables/* marketsMoversTimer.minutesInMilliseconds */.l5.minutesInMilliseconds;
        var specificTimeAgo = Date.now() - minutesInMilliseconds;
        var currentDate = new Date();
        var currentTime = currentDate.getTime();
        if (marketId > 0) {
            var ref;
            if (((ref = marketMovers[marketId]) === null || ref === void 0 ? void 0 : ref.marketIdTime) < specificTimeAgo || !(marketId in marketMovers)) {
                // console.log('marketID=>', marketId);
                var glapi = marketId == 100 ? "".concat(Requests/* zagTrader */.sV, "api/GainerLoserAPI.php?langid=2&sectorId=32&marketId=100") : "".concat(Requests/* zagTrader */.sV, "api/GainerLoserAPI.php?marketId=").concat(marketId);
                (0,GetData/* default */.Z)(glapi, {}, "get", false).then(function(res) {
                    var ref, ref1;
                    var parsedRes = (0,parseZagApiResponse/* parseApiResponse */.B)(res === null || res === void 0 ? void 0 : res.data);
                    if ((parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.gainers) && (parsedRes === null || parsedRes === void 0 ? void 0 : (ref = parsedRes.gainers) === null || ref === void 0 ? void 0 : ref.length) > 0 || (parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.losers) && (parsedRes === null || parsedRes === void 0 ? void 0 : (ref1 = parsedRes.losers) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                        var ref2, ref3, ref4;
                        var gainersList = (parsedRes === null || parsedRes === void 0 ? void 0 : (ref2 = parsedRes.gainers) === null || ref2 === void 0 ? void 0 : ref2.length) > 5 ? parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.gainers.slice(0, 5) : res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.gainers;
                        var losersList = (parsedRes === null || parsedRes === void 0 ? void 0 : (ref4 = parsedRes.losers) === null || ref4 === void 0 ? void 0 : ref4.length) > 5 ? parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.losers.slice(0, 5) : parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.losers;
                        var resultData = {
                            gainers: gainersList,
                            losers: losersList
                        };
                        var marketMoversContainer = (0,_object_spread/* default */.Z)({}, marketMovers);
                        marketMoversContainer = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketMoversContainer), (0,_define_property/* default */.Z)({}, marketId, {
                            data: resultData,
                            marketIdTime: currentTime
                        }));
                        dispatch((0,MarketMoversSlice/* setMarketMovers */.n)(marketMoversContainer));
                    }
                    setWait(false);
                }).catch(function(err) {
                    setWait(false);
                    setConnectionError(true);
                    console.warn(err);
                });
            } else {
                setWait(false);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "marketChart",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "yellowTitle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: ArabicTitles/* marketMoversTitle */.nO
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "chartBox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "chartTop",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "d-flex",
                                children: [
                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {}),
                                    // show bar chart menu
                                    (marketsList === null || marketsList === void 0 ? void 0 : marketsList.length) > 0 && marketsList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "nav-item",
                                            ref: function(el) {
                                                marketTabRefs.current[String(item.marketId)] = el;
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: function() {
                                                    return setMarketID(item === null || item === void 0 ? void 0 : item.marketId);
                                                },
                                                className: "nav-link ".concat((item === null || item === void 0 ? void 0 : item.marketId) === marketID ? "active" : ""),
                                                children: item.marketArabicName
                                            })
                                        }, item.marketId);
                                    })
                                ]
                            })
                        }),
                        wait && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                            count: 5
                        }),
                        connectionError && !wait && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center py-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: "Connection error. Please try again."
                            })
                        }),
                        !wait && marketID && marketID > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketMovers_MarketMovers, {
                            marketId: marketID
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SplitScreenBarCharts_SplitScreenBarCharts = (SplitScreenBarCharts);


/***/ }),

/***/ 95066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ parseApiResponse; }
/* harmony export */ });
var parseApiResponse = function(rawResponse) {
    try {
        // If response is already a proper object, return as-is
        if (typeof rawResponse === "object" && rawResponse !== null) {
            return rawResponse;
        }
        // If response is string, clean it
        if (typeof rawResponse === "string") {
            var cleaned = rawResponse.trim();
            // Remove leading "1" only if it is immediately before JSON object
            // Example: 1{"code":"R200"...}
            if (cleaned.startsWith("1{")) {
                cleaned = cleaned.substring(1);
            }
            return JSON.parse(cleaned);
        }
        return rawResponse;
    } catch (error) {
        console.error("Failed to parse API response:", error, rawResponse);
        return rawResponse;
    }
};


/***/ })

}]);